export const LogoIconWhite = '/images/logo_i_white.png';
export const LogoIcon = '/images/logo_i.png';
export const LogoWhite = '/images/logo_white.png';
export const Logo = '/images/logo.png';
export const Model = '/images/model.png';
export const Top = '/images/top.png';
export const bauesInc = '/images/baues_inc.png';
export const bauesIncWhite = '/images/baues_inc_white.png';
